function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.9462 26.6995V6.84678H81.0583V3.48602H59.0922V6.84678H68.239V26.6995H71.9462Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1746 27.0459C90.926 27.0459 94.7718 23.408 94.7718 18.107C94.7718 12.7368 90.926 9.13347 85.1746 9.13347C79.4579 9.13347 75.6121 12.7368 75.6121 18.107C75.6121 23.408 79.4579 27.0459 85.1746 27.0459ZM85.1746 23.7198C81.017 23.7198 79.2846 21.745 79.2846 18.107C79.2846 14.4345 81.017 12.4249 85.1746 12.4249C89.3669 12.4249 91.0992 14.4345 91.0992 18.107C91.0992 21.745 89.3669 23.7198 85.1746 23.7198Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.438 7.47042V3.48602H98.6958V7.47042H102.438ZM102.438 26.6995V9.47994H98.6958V26.6995H102.438Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M118.406 26.6995V23.3387H115.288C113.14 23.3387 112.17 22.7844 112.17 20.6709V12.5982H118.406V9.47994H112.17V3.48602H108.462V9.47994H105.552V12.5982H108.462V20.8788C108.462 25.0711 110.749 26.6995 114.456 26.6995H118.406Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.63583 0.000201677C1.76711 -0.00184701 1.90076 0.0122317 2.03435 0.0439443L19.8745 4.27905C19.8966 4.28429 19.9186 4.29001 19.9405 4.29618C21.8661 4.84022 23.8958 4.88937 25.8418 4.44209C26.1412 4.32523 26.4513 4.22772 26.7709 4.15122L43.9286 0.0446348C44.0567 0.0139608 44.185 -0.000473485 44.3112 1.22037e-05C45.0403 -0.00267321 45.703 0.493183 45.882 1.23284C46.0912 2.09784 45.5597 2.9687 44.6947 3.17797L27.7378 7.28047L27.0498 7.46277C26.981 7.48101 26.912 7.49875 26.843 7.51601C25.4797 8.12633 24.5691 9.49021 24.5691 11.0274L24.5691 12.6372C24.5691 13.6734 24.8679 14.6876 25.4298 15.5582L32.1443 25.9636C32.9609 27.229 34.7511 27.3859 35.7754 26.2818L43.1223 18.3624C43.7276 17.71 44.7472 17.6718 45.3996 18.277C46.052 18.8823 46.0903 19.9019 45.485 20.5543L38.1381 28.4737C35.6835 31.1196 31.3933 30.7436 29.4364 27.711L22.9577 17.6712L16.479 27.711C14.5221 30.7435 10.232 31.1196 7.77736 28.4737L0.430436 20.5543C-0.174828 19.9019 -0.136595 18.8823 0.515833 18.277C1.16826 17.6718 2.18782 17.71 2.79309 18.3624L10.14 26.2818C11.1643 27.3859 12.9545 27.229 13.7711 25.9636L20.4857 15.5582C21.0475 14.6876 21.3463 13.6734 21.3463 12.6372V10.4752C21.3463 9.01905 20.3475 7.75295 18.9313 7.414L1.23668 3.17889C0.371175 2.97174 -0.162523 2.10218 0.0446303 1.23668C0.223664 0.48866 0.897478 -0.0115192 1.63583 0.000201677Z",
  fill: "white"
});

var SvgToitLogo = function SvgToitLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 31,
    viewBox: "0 0 119 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToitLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toit-logo.f91e644e.svg";
export { ForwardRef as ReactComponent };